<template>
  <ContentSection>
    <Container indent="wide">
      <div class="justify-between gap-10 lg:flex">
        <h2
          v-if="data.heading"
          class="default-component-title"
          :class="data.link ? 'mb-3 xl:mb-8' : 'mb-8 sm:mb-10'"
          v-html="$replaceHtmlTags(data.heading)"
        />

        <AppLink
          v-if="data.link && data.link_text"
          class="mb-7 sm:text-md xl:mb-0"
          :to="data.link"
          :target="data.target?.value"
        >
          {{ data.link_text }}
        </AppLink>
      </div>
      <AnimatedContainer>
        <ul class="grid gap-4">
          <li v-for="job in jobs" :key="job.id" class="fade-in">
            <JobCard :data="job" />
          </li>
        </ul>
      </AnimatedContainer>
    </Container>
  </ContentSection>
</template>

<script setup>
const props = defineProps({
  data: { type: Object, default: () => ({}) },
})

const pageId = inject('pageId', null)

const { locale } = useI18n()
const fetchedJobs = ref(null)

// FUNCTIONS
async function fetchJobs() {
  let payload = await useAsyncGql({
    operation: 'Jobs',
    variables: {
      sort: 'date desc',
      limit: 3,
      filter: {
        site: locale.value,
        id: { not: pageId },
        section: switchContainsOrIn(props.data?.restricted_sections),
      },
    },
  })

  payload = payload.data.value?.entries

  if (!payload) {
    console.error('JobsTeaser: Jobs could not be fetched')
    return
  }

  fetchedJobs.value = payload.data
}

// COMPUTED
const jobs = computed(() => {
  if (props.data.selection.value === 'automatic') {
    return fetchedJobs.value || []
  }

  return props.data.jobs || []
})

// WATCHERS
watch(
  () => props.data,
  async (newValue) => {
    if (newValue.selection?.value === 'automatic') {
      await fetchJobs()
    }
  },
  { deep: true }
)

// INITIAL
if (props.data.selection.value === 'automatic') {
  await fetchJobs()
}
</script>
